const peiAffirmativeLetterStatuses = {
  Nuevo: 'Nuevo',
  Sometido: 'Sometido',
};

export default peiAffirmativeLetterStatuses;
